import { createContext } from 'react';
import { Client } from 'contentful/getClients';
import { ExperienceEntry } from '@contentful/getExperiences';
import { CaseStudyEntry } from '@contentful/getCaseStudies';

interface ClientContextType {
    clients: Client[] | null;
}

interface ExperienceContextType {
    experiences: ExperienceEntry[] | null;
    isError?: boolean;
}

interface CaseStudyContextType {
    caseStudies: CaseStudyEntry[] | null;
}

export const ClientContext = createContext<ClientContextType | undefined>(undefined);
export const ExperienceContext = createContext<ExperienceContextType | undefined>(undefined);
export const CaseStudyContext = createContext<CaseStudyContextType | undefined>(undefined);
